// extracted by mini-css-extract-plugin
export var boxItems = "_cb-1";
export var boxItemsLg = "_cb-2";
export var button = "_cb-7";
export var buttonHoverless = "_cb-9";
export var buttonLg = "_cb-8";
export var filterGroupBox = "_cb-0";
export var icon = "_cb-3";
export var iconSecondary = "_cb-6";
export var iconWrapper = "_cb-4";
export var iconWrapperLg = "_cb-5";
export var truncatedLabel = "_cb-a";